/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
//aiconsultant
const clientid = "4f2dc587-5caa-47a1-860d-6d4049611d78";
const authURL = "https://aiconsultantllc.b2clogin.com/aiconsultantllc.onmicrosoft.com/B2C_1_newsignup"
//identity-client-spa
//const tenantid = "f01eb45a-9851-439d-8a81-70caadd5a9bb";
//const clientid = "dfbab785-18fa-4a2d-990a-d1f0b343d594";

export const msalConfig = {
    auth: {
        clientId: clientid,
        authority: authURL,
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
        knownAuthorities: ["aiconsultantllc.b2clogin.com"],
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        //console.error(message);
                        return;
                    case LogLevel.Info:
                        ////console.info(message);
                        return;
                    case LogLevel.Verbose:
                        ////console.debug(message);
                        return;
                    case LogLevel.Warning:
                        //console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};
